import { Team } from "../team/team";

export class Modu {
  authorizationUrl: string;
}

export class Policy {
  privacyPolicy?: boolean; // 개인정보 취급방침 변경 여부 (true | false)
  privacyPolicyDate?: string; // 개인정보 취급방침 동의 시간 ("2021-05-07 20:52:56")
  thirdParty?: boolean; // 3자 제공 동의 여부 (true | false)
  thirdPartyDate?: string; // 3자 제공 동의 시간 ("2021-05-07 20:53:55")
}

export class Credit {
  credit: number; // 현재
  deduct: number; // 소멸예정 (전월)
}

export class CreditCharge {
  price: number; // 추가 과금액
  multiply: number; // 크레딧당 단위
  overuse: number; // 추가 사용량
  provided: number; // 기초 제공량
  credit: number; // 현재 크레딧

  newPrice: number; // 추가 과금액
  newOveruse: number; // 추가 사용량
  newCredit: number; // 현재 크레딧
}

export class CreditHistoryItem {
  reg_dt: string; // 날짜
  se: string; // 구분코드
  se_nm: string; // 구분명
  qy: string; // 수량
}

export class Print {
  color: number;
  black: number;
}

export class PrintHistoryItem {
  reg_dt: string;
  de: string; //사용일
  time: string; //사용시간
  mem_nm: string; //맴버명
  color: string; //색상
  se: string; //구분코드
  se_nm: string; //구분명
  qy: number; // 수량
  qy_count: number; // 수량합
  memo: string;
  member: {
    name: string;
    nick: string;
  };
}

export class PageInvoiceHistory {
  items: InvoiceHistoryItem[];
  size: number;
  number: number;
}

export class InvoiceHistoryItem {
  sls_mm: string;
  sls_de: string;
  amt_msh_sum: number | string;
  amt_vat_sum: number | string;
  excend_mmdd: string;
  trc_mthd: string;
  email: string;
  tel: string;
}

export class Member {
  disabledPush: boolean;
  id: number;
  team: Team;
  email: string;
  location: {
    key: string;
    name: string;
    code: string;
  };
  name: string;
  nick: string;
  photo: string;
  work: string;
  intro: string;
  contact: string;
  contactLocked: boolean;
  snsUrl: string;
  interest: string;
  agree: boolean;
  role: string;
  seatNo: string;
  seatLocked: boolean;
  birthYear: string;
  closedInfo: boolean;
  cardNo: string;
  channelIOHash: string;
}

export class MemberPage {
  content: Member[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}

export class createMember {
  id?: number;
  email: string;
  role: string; //  "ROLE_USER", "ROLE_MANAGER", "ROLE_ADMIN"
  cardNo: string;
  team: { id: number };
  location: { key: string };
}

export class MemberCard {
  cardNo: string;
  printPassword: string;
  status: string;
}

export class MemberActivityCount {
  countByBoard: number;
  countByComment: number;
  countByMessage: number;
  countByUnreadMessage: number;
}

export class ResetPassword {
  token: string;
  email: string;
  password: string;
}

export class ChangeEmail {
  email: string;
  changeEmail: string;
}

export class ChangeRole {
  email: string;
  role: string;
}

export class MemberTeam {
  id?: number;
  title: string;
  thumbnail: string;
  homepage: string;
  contact: string;
  email: string;
  summary: string;
  content: string;
  location: any;
}

export class MemberTeamPage {
  content: MemberTeam[];
  first: boolean;
  last: boolean;
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  sort: any;
  numberOfElements: number;
}



// WEBPACK FOOTER //
// ./src/app/service/member/member.ts